import React from "react";

const TextSummarization = () => {
  return (
    <div className="min-h-screen bg-black text-white flex flex-col items-center justify-center">
      <h1 className="text-5xl font-bold mb-8">Text Summarization</h1>
      <p className="text-gray-400 max-w-2xl text-center">
        Quickly summarize long pieces of text into concise, key ideas. Paste your content below to get started.
      </p>
      <textarea
        className="mt-4 w-full max-w-2xl bg-gray-800 text-white p-4 rounded-lg"
        rows={8}
        placeholder="Paste your text here..."
      ></textarea>
      <button className="mt-4 px-6 py-3 bg-gradient-to-r from-yellow-400 to-red-400 text-white font-bold rounded-lg shadow-lg">
        Summarize Text
      </button>
    </div>
  );
};

export default TextSummarization;